import { getNames } from './mapUtils';

const toIconClassName = (iconName: string) => `icon-${iconName}`;

export const getIconNames = (...iconGroups: Parameters<typeof getNames>) =>
    getNames(...iconGroups).map(toIconClassName);

export const icons = {
    vehicles: [
        {
            name: 'car',
        },
        {
            name: 'bus',
        },
        {
            name: 'van',
        },
        {
            name: 'truck',
        },
        {
            name: 'trailer',
        },
    ],
    humans: [
        {
            name: 'user',
        },
        {
            name: 'driver',
        },
        {
            name: 'businessman',
        },
    ],
    arrows: [
        {
            name: 'arrow-up',
        },
        {
            name: 'arrow-down',
        },
        {
            name: 'arrow-left',
        },
        {
            name: 'arrow-right',
        },
    ],
    chevron: [
        {
            name: 'chevron-down',
        },
        {
            name: 'chevron-up',
        },
        {
            name: 'chevron-left',
        },
        {
            name: 'chevron-right',
        },
    ],
};

const iconLibrary = [...getNames(icons.vehicles, icons.humans)];
export const getRandomIcon = () => toIconClassName(iconLibrary[Math.floor(Math.random() * iconLibrary.length)]);
